@let value = valueSg();
@let valueInfo = valueInfoSg();
@let type = typeSg();
@let rawValue = rawValueSg();
@let listValue = listValueSg();

@if (type === IntrinsicEnum.Boolean) {
  <atn-value-boolean [value]="!!value" />
} @else if (listValue) {
  <atn-value-list [value]="listValue" />
} @else if (
  type === IntrinsicEnum.Currency ||
  type === IntrinsicEnum.Integer ||
  type === IntrinsicEnum.Percent
) {
  <atn-value-number
    [value]="rawValue"
    [valueInfo]="valueInfo"
    data-test-id="atn-cell-value"
  />
} @else if (rawValue) {
  <atn-ds-value
    [value]="rawValue"
    [valueInfo]="valueInfo"
    data-test-id="atn-cell-value"
  />
}

<!-- NOTE: in case we gonna want to override some properties to be different
then atn-ds-value, we should do it here -->
